import type { ExclusiveOffer } from '@workspace/global-utils';
import { authenticatedNextFetch } from '../api-service';

const OFFER_PATH = '/api/offers/current';

export const getCurrentOffer = async (): Promise<ExclusiveOffer | null> => {
  const response = await authenticatedNextFetch(OFFER_PATH);
  if (!response.ok) return null;
  const body = (await response.json().catch(() => null)) as {
    offer?: ExclusiveOffer | null;
  } | null;
  return body?.offer ?? null;
};

export const recordFounderClick = () =>
  authenticatedNextFetch(OFFER_PATH, {
    method: 'POST',
    body: JSON.stringify({ event: 'founder_clicked' }),
  });
